export const buildInfo = {
  "version": "0.1.0",
  "commit": "2300e4595b6d",
  "fullCommit": "2300e4595b6d0218b4af0b25b6b34bc993d24777",
  "sourceCommitSubject": "feat: turn the checklist into a real bootstrap map with references and snippets",
  "builtAt": "2026-05-11T19:19:49.051Z",
  "repositoryUrl": "https://github.com/baditaflorin/project-bootstrap-meta",
  "paypalUrl": "https://www.paypal.com/paypalme/florinbadita",
  "liveUrl": "https://baditaflorin.github.io/project-bootstrap-meta/"
} as const;
